import React, { useState, useEffect } from "react";
import Layout from "../Layout";
import Sidebar from "../Sidebar";
import BannerModal from "./BannerModal"; // <-- our refactored modal (add/edit)
import { AiOutlineDelete } from "react-icons/ai";
import { useQuery, gql, useMutation } from "@apollo/client";
import Loader from "../../Loader";
import { useAuthz } from "../../auth/useAuthz";

const GET_BANNERS = gql`
  query {
    getBanners {
      status
      message
      bannerList {
        id
        image
        isPromotional
        isFeatured
        isRefer
        gender
      }
    }
  }
`;

const DELETE_BANNER = gql`
  mutation deleteBanner($data: ID!) {
    deleteBanner(data: $data) {
      status
      message
    }
  }
`;

const Banners = () => {
  const { can } = useAuthz();
  const [modalState, setModalState] = useState({ open: false, banner: null });
  const [isFetched, setIsFetched] = useState(false);
  const [dataList, setDataList] = useState([]);
  const { loading, error, data } = useQuery(GET_BANNERS);

  const [deleteBanner, { loading: deleteLoading }] = useMutation(DELETE_BANNER);

  useEffect(() => {
    if (data?.getBanners?.bannerList) {
      setDataList(data.getBanners.bannerList);
      setIsFetched(true);
    }
  }, [data]);

  if (loading || deleteLoading || !isFetched) return <Loader />;
  if (error) {
    return (
      <p className="text-red-500">An error occurred while fetching banners.</p>
    );
  }

  const handleRemoveRow = (dataId) => {
    deleteBanner({
      variables: { data: dataId },
    }).then((res) => {
      if (res.data.deleteBanner.status === "SUCCESS") {
        window.location.reload();
      }
    });
  };

  return (
    <div className="min-h-screen flex">
      <Sidebar />
      {isFetched && (
        <Layout>
          <div className="flex flex-col">
            <p
              className={`text-[#FBB034] rounded-sm cursor-default text-2xl px-2 py-1 font-normal font-be-jost-pro text-center md:text-left`}
            >
              Current Banners
            </p>
            <div className="flex justify-between items-start flex-wrap w-[90%] lg:w-4/5">
              {dataList.length > 0 ? (
                dataList.map((item) => (
                  <div
                    key={item.id}
                    className="lg:w-[45%] my-4 mx-3 p-3 border border-gray-700 rounded-md relative"
                  >
                    {/* Banner Image */}
                    <img
                      src={`https://api.barbera.in${item.image}`}
                      className="w-full rounded"
                      alt="banner"
                    />

                    {/* Delete button */}
                    <AiOutlineDelete
                      className="text-[#FBB033] text-2xl cursor-pointer absolute top-2 right-2"
                      onClick={() => handleRemoveRow(item.id)}
                    />

                    {/* Banner Info */}
                    <div className="mt-2 text-white text-sm space-y-1">
                      <p>
                        <span className="font-bold">Gender:</span> {item.gender}
                      </p>
                      <p>
                        <span className="font-bold">Refer:</span>{" "}
                        {item.isRefer ? "Yes" : "No"}
                      </p>
                      <p>
                        <span className="font-bold">Promotional:</span>{" "}
                        {item.isPromotional ? "Yes" : "No"}
                      </p>
                      <p>
                        <span className="font-bold">Featured:</span>{" "}
                        {item.isFeatured ? "Yes" : "No"}
                      </p>
                    </div>

                    {/* Edit Button */}
                    {can("banners.edit") && (
                      <button
                        className="mt-3 bg-[#FBB034] text-[#202125] py-1 px-3 rounded text-sm font-bold"
                        onClick={() =>
                          setModalState({ open: true, banner: item })
                        }
                      >
                        Edit
                      </button>
                    )}
                  </div>
                ))
              ) : (
                <p className="text-gray-400">No banners uploaded yet.</p>
              )}
            </div>

            {/* Add Banner Button */}
            {can("banners.create") && (
              <button
                className="mt-10 lg:ml-3 text-[#FBB033] font-be-jost-pro font-medium text-sm border border-[#FBB033] rounded-md py-2 px-3 w-full lg:w-[10%]"
                onClick={() => setModalState({ open: true, banner: null })}
              >
                Upload Banner
              </button>
            )}
          </div>
        </Layout>
      )}

      {/* Modal for Add/Edit */}
      {modalState.open && (
        <BannerModal
          setShowModal={() => setModalState({ open: false, banner: null })}
          initialData={modalState.banner}
        />
      )}
    </div>
  );
};

export default Banners;
